import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

export const PasslyAlert = withStyles((theme: Theme) => ({
    root: {
        width: '100%',
        padding: '6px 12px'
    },
    outlinedInfo: {
        borderLeftWidth: 6,
        backgroundColor: theme.palette.background.paper
    }
}))(MuiAlert);